/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useMemo, useState } from "react"
import { Box, IconButton, Paper, Radio, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { Formater, TypeRecords } from "src/framework/commons/Formater"
import theme from "src/theme/light"
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade"
import { useHistory } from "react-router-dom"
import { ListagemItem, InversorModuloResponse, ModuloListagem, ModuloPorRegiaoListagemResponse, Option } from "src/components/projetos/types"
import { setPersonalizadoTabDisabledStatus } from "src/store/vendas/projetos/actions"
import { Layout } from "../../layouts"
import { redirecionarParaProjetoVertical } from "src/components/projetos/utils/redirecionarParaProjetoVertical"
import { MODULO_POTENCIA_MAXIMA_ATTR, INVERTER_MAX_POWER_ATTR, MODULO_POWER_ATTR, MODULO_POTENCIA_MINIMA_ATTR, NOVO_PROJETO_ENGENHARIA, INVERSOR_CARREGADOR_TENSAO_MAXIMA_ENTRADA, CONTROLADOR_MAXIMA_POTENCIA_FOTOVOLTAICA_ATTR, MODULO_MODULO_TENSAO_VOC_ATTR, INVERTER_MAX_POWER_INPUT_ATTR } from "src/components/projetos/constants"
import { ComponenteProvider } from "src/providers/estoque/ComponenteProvider"
import { potenciaTotalMaiorQuePotenciaMaxima } from "src/components/projetos/utils/potenciaTotalMaiorQuePotenciaMaxima"
import { checarParametroRegiaoPotencia } from "src/components/projetos/utils/checarParametroRegiaoPotencia"
import { potenciaTotalMenorQuePotenciaMinima } from "src/components/projetos/utils/potenciaTotalMenorQuePotenciaMinima"
import { ALERT_MOSTRAR_PARAMETRO_REGIAO_POTENCIA, ALERT_MOSTRAR_POTENCIA_TOTAL_MAIOR_QUE_POTENCIA_MAXIMA, ALERT_POPUP_PARCEIRO, alertsList$, clearIntervalAlerts, setAlertsList, startIntervalAlerts, TAlertsDom, ALERT_MIN_MODULES, ALERT_MIN_INVERTERS } from "src/framework/store/ProcessarFilaMensagensStore"
import { FindInPageOutlined } from "@mui/icons-material"
import ModulosListMobile from "src/components/projetos/containers/Mobile/ModulosListMobile"
import InversoresListMobile from "src/components/projetos/containers/Mobile/InversoresListMobile"
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList";
import { inversoresMap, ID_INVERSOR_HIBRIDO } from "src/components/componentes/types";
import { useProjetoPersonalizadoHibridoStore } from "src/store/vendas/projetos/personalizado_hibrido/personalizadoHibrido.store";
import { ProjetoPersonalizadoHibridoData } from "src/store/vendas/projetos/personalizado_hibrido/personalizadoHibrido.types";
import { checarPotenciaTotal, ModalType } from "src/components/projetos/utils/checarPotenciaTotal";

export const POTENCIA_MAXIMA_PERSONALIZADO_HIBRIDO = 5000;
const useStyles = makeStyles({
  quantityHelperText: {
    color:  theme.palette.error.main,
    display: 'block',
    textAlign: 'left',
    marginLeft: 25,
  },
  warningText: {
    color: theme.palette.warning.main,
    fontWeight: 600,
  },
  moduleTitle: {
    fontWeight: 600,
  },
  radioButton: {
    marginRight: 14,
  }
})

interface GeradorProps {
  onClickBack: () => void
  onClickNext: () => void
}

const componenteProvider = new ComponenteProvider()
const buscarVinculosModulo = async (moduloId: number, lista: ListagemItem[] = [], filters: { regiao_id?: number[]; categorias?: number[]; segmento?: string } = {}) => {
  if (moduloId) {
    const resultItens = await componenteProvider.buscarInversoresPorModuloId(moduloId, filters)
    if(!resultItens.length) return []

    const result: ListagemItem[] = resultItens.map((item: InversorModuloResponse): ListagemItem => {
      const potencia = item.atributos.find(item => item.atributo === INVERTER_MAX_POWER_ATTR)
      const potenciaMaximaEntradaCC = item.atributos.find(item => item.atributo === INVERTER_MAX_POWER_INPUT_ATTR)
      const tensaoMaximaEntrada = item.atributos.find(item => item.atributo === INVERSOR_CARREGADOR_TENSAO_MAXIMA_ENTRADA)
      const maximaPotenciaFV = item.atributos.find(item => item.atributo === CONTROLADOR_MAXIMA_POTENCIA_FOTOVOLTAICA_ATTR)
      const savedItem = lista.find(i => i.componente_id === item.id)

      return {
        potenciaMaximaEntradaCC: Number(potenciaMaximaEntradaCC?.valor || 0),
        tensaoMaximaEntrada: Number(tensaoMaximaEntrada?.valor || 0),
        maximaPotenciaFV: Number(maximaPotenciaFV?.valor || 0),
        componente_id: item.id,
        nome: item.nome,
        modelo: item?.modelo,
        descricao: item.descricao,
        quantidade: savedItem?.quantidade || 0,
        altura: item.altura,
        largura: item.largura,
        peso: item.peso,
        valor: 0,
        categoria_componentes_id: item.categoria_componentes_id,
        potencia: Number(potencia?.valor || 0),
        valor_unitario: savedItem?.valor_unitario || 0,
        exibir_popup_parceiro: item?.exibir_popup_parceiro,
      }
    })
    return result;
  }
}

let timerBuscarVinculos: NodeJS.Timeout;

const Gerador = ({ onClickNext, onClickBack }: GeradorProps) => {
  const projetoState = useProjetoPersonalizadoHibridoStore(store => store.state.data);
  const { changeValue, changeValidation, changeModal, reset} = useProjetoPersonalizadoHibridoStore(store => store.actions);
  const history = useHistory();
  const classes = useStyles();

  const [modulosList, setModulosList] = useState<ModuloListagem[]>([]);
  const [fraseParceiroExibidoList, setFraseParceiroExibidoList] = useState<number[]>([]);
  const [tipoInversor, setTipoInversor] = useState<Option<number> | null>(inversoresMap[ID_INVERSOR_HIBRIDO])

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const openItensAlert = (status: boolean, type?: ModalType): string | null => {
    if (status) {
      if (type === 'min-inverters') return ALERT_MIN_INVERTERS;
      if (type === 'min-modulos') return ALERT_MIN_MODULES;
    }

    return null;
  }

  const showMaxPowerNotify = useCallback(() => {
    redirecionarParaProjetoVertical({
      onNegation: () => {
        reset()
        changeValue(NOVO_PROJETO_ENGENHARIA)
        history.push('/projetos/verticais/novo', { allowAccess: true, tipo: 'personalizado_hibrido' })
      },
      yesText: 'Continuar personalizando'
    })
  },[history, projetoState])

  const selectedModulo = useMemo(()=>{
    return modulosList.find(item => item.selecionado)
  },[modulosList])

  const listarVinculos = useCallback((state: ProjetoPersonalizadoHibridoData) => {
    clearTimeout(timerBuscarVinculos)
    timerBuscarVinculos = setTimeout(() => {
      const moduloSelecionado = state.modulosList?.find(item => item.selecionado)
      if (!moduloSelecionado) return;
      const regioesIds = state.regioes.map(item => item.id)

      buscarVinculosModulo(moduloSelecionado.componente_id, state.inversoresList, { categorias: [ID_INVERSOR_HIBRIDO], regiao_id: regioesIds, segmento: "on"}).then(result => {
        changeValue({ inversoresList: result || []})
      })
    }, 300)
  },[]);

  useEffect(()=>{
    const carregarDadosIniciais = async () => {
      const currentRegioes = projetoState.regioes || []
      if (!currentRegioes.length) return;

      componenteProvider.buscarModulosPorRegiao(currentRegioes.map((item: any) => item.id), undefined, "personalizado", ID_INVERSOR_HIBRIDO, undefined, undefined, "on").then((res) => {
        if(res.length) {
          const items: ModuloPorRegiaoListagemResponse[] = res || []

          const result = items.map((modulo: ModuloPorRegiaoListagemResponse) => {
            const potencia = modulo.atributos.find(item => item.atributo === MODULO_POWER_ATTR)
            const savedItem = projetoState.modulosList ? projetoState.modulosList.find(item => item.componente_id === modulo.id) : null

            listarVinculos(projetoState)

            const potenciaMaxima = modulo.atributos.find(item => item.atributo === MODULO_POTENCIA_MAXIMA_ATTR)
            const potenciaMinima = modulo.atributos.find(item => item.atributo === MODULO_POTENCIA_MINIMA_ATTR)
            const tensaoVocModulo = modulo.atributos.find(item => item.atributo === MODULO_MODULO_TENSAO_VOC_ATTR)

            return {
              potenciaMaxima: Number(potenciaMaxima?.valor || 0),
              potenciaMinima: Number(potenciaMinima?.valor || 0),
              tensaoVocModulo: Number(tensaoVocModulo?.valor || 0),
              componente_id: modulo.id,
              inversoresTipos: [],
              categoria_componentes_id: modulo.categoria_componentes_id,
              potencia: Number(potencia?.valor || 0),
              faturamento: modulo.data_previsao_faturamento ? new Date(modulo.data_previsao_faturamento).toISOString() : undefined,
              nome: modulo.nome,
              descricao: modulo.descricao,
              quantidade: savedItem?.quantidade || 0,
              selecionado: savedItem?.selecionado || false,
              categoria: modulo.categoria_componentes_nome,
              altura: modulo.altura,
              largura: modulo.largura,
              peso: modulo.peso,
              valor: 0, // Calculado no backend
              comprimento: modulo.comprimento,
              valor_unitario: savedItem?.valor_unitario || 0,
              regioes_parametros: modulo?.regioes_parametros,
              exibir_popup_parceiro: modulo?.exibir_popup_parceiro,
            }
          })
          setModulosList(result)
          changeValue({ modulosList: result })
        }

        // iniciando intervalo de mensagens
        clearIntervalAlerts();
        startIntervalAlerts();
      })
    }

    carregarDadosIniciais();
  },[projetoState.regioes])

  const isGreatherThanPowerLimitForCustomProjects = useCallback(()=>{
    const pot = selectedModulo?.potencia || 0
    const numModulos = selectedModulo?.quantidade || 0
    const powerInKw = (pot * numModulos) / 1000
    return powerInKw > POTENCIA_MAXIMA_PERSONALIZADO_HIBRIDO;
  },[selectedModulo])

  const checarSePotenciaTotalMaiorQuePotenciaMaxima = useCallback(( moduloSelecionado: ModuloListagem | null = selectedModulo || null ): { status: boolean; potenciaMaxima: number; } =>{
    return potenciaTotalMaiorQuePotenciaMaxima(moduloSelecionado)
  },[selectedModulo]);

  const checarSePotenciaTotalMenorQuePotenciaMinima = useCallback(( moduloSelecionado: ModuloListagem | null = selectedModulo || null ): { status: boolean; potenciaMinima: number; } =>{
    return potenciaTotalMenorQuePotenciaMinima(moduloSelecionado)
  },[selectedModulo]);

  const checarPotenciaTotalEstaNoRangePotenciaRegiao = useCallback(( moduloSelecionado: ModuloListagem | null = selectedModulo || null ): { status: boolean; parametro: any; } =>{
    return checarParametroRegiaoPotencia(moduloSelecionado)
  },[selectedModulo]);
  
  const checkItensIsInvalid = useCallback((): { status: boolean} => {
    if (!selectedModulo) return { status: false }
    return { status: false }
  },[selectedModulo]);

  const checkTotalPowerIsInvalid = useCallback((): { status: boolean, type?: ModalType } => {
    if (!selectedModulo) return { status: false }
    if(!projetoState?.inversoresList?.length) return { status: false }
    return checarPotenciaTotal(selectedModulo, projetoState?.inversoresList); 
  },[projetoState?.inversoresList, selectedModulo])

  const handleChangeModuleQuantity = useCallback((id: number, value: string)=> {
    const quantidade = Number(value || 0);
    const state = { ...projetoState }
    const newModulosList = modulosList.map((item) => ({ ...item, quantidade }));
    const _alertasList: TAlertsDom[] = alertsList$.getValue();

    changeValue({ modulosList: newModulosList})
    setModulosList(newModulosList)

    // Verifica limites de potência
    const moduloAtualizado = newModulosList.find(item => item.selecionado) || null;
    const { status, type } = moduloAtualizado
      ? checarPotenciaTotal(moduloAtualizado, projetoState?.inversoresList || [])
      : { status: false, type: undefined };
    const alerta = openItensAlert(status, type);
    if(alerta) {
      _alertasList.push({
        alert: alerta
      });
    }

    listarVinculos(state)
  },[checarSePotenciaTotalMaiorQuePotenciaMaxima, checarSePotenciaTotalMenorQuePotenciaMinima, listarVinculos, projetoState, modulosList, changeValue]);

  /*const checkInverterQuantityIsInvalid = useCallback((id?: number, value?: number) => {
    const itens = projetoState?.inversoresList || [];
    const quantity = selectedModulo?.quantidade || 0;
    return checarNumeroMaximoDeItens(itens, quantity, id, value);
  }, [projetoState?.inversoresList, selectedModulo]);*/

  const handleChangeQuantity = useCallback((id: number, value: string, list: ListagemItem[]) => {
    const _alertasList: TAlertsDom[] = alertsList$.getValue();
    const quantidade = Number(value || 0);

    const listKey = 'inversoresList';
    const newList = list.map(item => item.componente_id === id ? { ...item, quantidade } : item );
    const selected = newList.find(item => item.componente_id === id);

    if (selected?.exibir_popup_parceiro) {
      const idx = fraseParceiroExibidoList.findIndex(c => c === id);
      if (idx < 0 && quantidade > 0) {
        _alertasList.push({ alert: ALERT_POPUP_PARCEIRO });
        setFraseParceiroExibidoList([...fraseParceiroExibidoList, id]);
      } else if (quantidade === 0 && idx >= 0) {
        setFraseParceiroExibidoList(fraseParceiroExibidoList?.filter(i => i !== id));
      }
    }

    changeValue({ [listKey]: newList });

    const { status, type } = selectedModulo ? checarPotenciaTotal(selectedModulo, newList) : { status: false, type: undefined };
    if (status) {
      const alerta = openItensAlert(status, type);
      if(alerta) {
        _alertasList.push({
          alert: alerta
        });
      }
    }
  }, [projetoState?.inversoresList, changeValue, projetoState?.modulosList, selectedModulo]);
  
  const handleSelect = useCallback((id: number) => {
    const currentSelected = modulosList.find(item => item.selecionado)
    if (currentSelected?.componente_id === id) return;

    const state = { ...projetoState }
    const newModulosList = modulosList.map((item) => {
      const selecionado = item.componente_id === id;
      return {
        ...item,
        selecionado,
        quantidade: 0
      };
    });

    state.modulosList = newModulosList
    changeValue({ 
      modulosList: newModulosList, 
      estruturasSelecionadas: [], 
      inversoresList: projetoState?.inversoresList?.map(i => ({...i, quantidade: 0})) || [],
    })
    setModulosList(newModulosList)
    listarVinculos(state)
  },[listarVinculos, projetoState, modulosList, changeValue])

  const potenciaTotal = useMemo<number>(() => {
    const moduloSelecionado = projetoState.modulosList?.find(item => item.selecionado);
    const potencia = moduloSelecionado?.potencia || 0;
    const quantidade = moduloSelecionado?.quantidade || 1;
    return Number((potencia / 1000.0 * quantidade).toFixed(2));
  },[projetoState?.modulosList]);

  const potenciaInvalida = useMemo<boolean>(() => {
    return potenciaTotal > POTENCIA_MAXIMA_PERSONALIZADO_HIBRIDO;
  },[potenciaTotal]);

  const nextButtonIsDisabled = useMemo(()=>{
    const selectedModulo = projetoState?.modulosList?.find(item => item.selecionado);
    const inversoresTotal = projetoState?.inversoresList?.reduce((acc,curr) => acc + curr.quantidade, 0);

    if (!selectedModulo || selectedModulo?.quantidade === 0) return true;

    if (selectedModulo?.regioes_parametros?.length) {
      if (checarPotenciaTotalEstaNoRangePotenciaRegiao().status === false) return true;
    } else {
      if (checarSePotenciaTotalMaiorQuePotenciaMaxima().status) return true;
      if (checarSePotenciaTotalMenorQuePotenciaMinima().status) return true;
    }
    if (checkItensIsInvalid().status) return true;
    if (checkTotalPowerIsInvalid().status) return true;
    if (isGreatherThanPowerLimitForCustomProjects()) return true;
    if (inversoresTotal === 0) return true;
    if (potenciaInvalida) return true;
    return false;
  },[checarSePotenciaTotalMaiorQuePotenciaMaxima, checarSePotenciaTotalMenorQuePotenciaMinima, checarPotenciaTotalEstaNoRangePotenciaRegiao, isGreatherThanPowerLimitForCustomProjects, projetoState?.modulosList, projetoState?.inversoresList, checkItensIsInvalid, potenciaInvalida, checkTotalPowerIsInvalid, handleChangeQuantity, handleChangeModuleQuantity])

  useEffect(()=>{
    setPersonalizadoTabDisabledStatus('estruturas', nextButtonIsDisabled)
    changeValidation({ gerador: !nextButtonIsDisabled });
  },[nextButtonIsDisabled])

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!selectedModulo) return;
      const _alertasList: TAlertsDom[] = alertsList$.getValue();

      // Verifica parâmetros de potência configurada
      if (selectedModulo.regioes_parametros?.length) {
        const { status, parametro } = checarParametroRegiaoPotencia(selectedModulo);

        if (!status) {
          _alertasList.push({
            alert: ALERT_MOSTRAR_PARAMETRO_REGIAO_POTENCIA,
            data: {
              potencia_inicial: parametro?.potencia_inicial,
              potencia_final: parametro?.potencia_final
            }
          });
        }
      } else {
        const { status: potenciaInvalida, potenciaMaxima } = potenciaTotalMaiorQuePotenciaMaxima(selectedModulo);

        if (potenciaInvalida) {
          _alertasList.push({
            alert: ALERT_MOSTRAR_POTENCIA_TOTAL_MAIOR_QUE_POTENCIA_MAXIMA,
            data: { potencia_maxima: potenciaMaxima }
          });
        }

        const { status: potenciaMinimaInvalida, potenciaMinima } = potenciaTotalMenorQuePotenciaMinima(selectedModulo);

        if (potenciaMinimaInvalida) {
          _alertasList.push({
            alert: ALERT_MOSTRAR_POTENCIA_TOTAL_MAIOR_QUE_POTENCIA_MAXIMA,
            data: { potencia_minima: potenciaMinima }
          });
        }
      }

      if (_alertasList.length) {
        setAlertsList(_alertasList);
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [selectedModulo, checarParametroRegiaoPotencia, potenciaTotalMaiorQuePotenciaMaxima, potenciaTotalMenorQuePotenciaMinima]);

  useEffect(() => {
    // Verifica se o projeto ultrapassa o limite de potência
    if (isGreatherThanPowerLimitForCustomProjects()) {
      showMaxPowerNotify()
    }

    // Verifica se exibe frase parceiro
    const _alertasList: TAlertsDom[] = alertsList$.getValue();
    if (selectedModulo && selectedModulo.exibir_popup_parceiro) {
      const idx = fraseParceiroExibidoList.findIndex(c => c === selectedModulo.componente_id);
      if (idx < 0) {
        setFraseParceiroExibidoList([...fraseParceiroExibidoList, selectedModulo.componente_id]);
        _alertasList.push({ alert: ALERT_POPUP_PARCEIRO });
      } else if (selectedModulo?.quantidade === 0 && idx >= 0) {
        setFraseParceiroExibidoList(fraseParceiroExibidoList?.filter(i => i !== selectedModulo.componente_id));
      }
    }
  },[selectedModulo?.componente_id, selectedModulo?.quantidade]);
  
  const renderModulos = useCallback(() => {
    if (isMobile) {
      return (
        <ModulosListMobile 
          modulosList={modulosList || []}
          handleSelect={handleSelect}
          handleChangeModuleQuantity={handleChangeModuleQuantity}
          handleOpenModalDadosTecnicos={changeModal}
          stringAvatarImg={""}
          microinversorAvatarImg={""}
          titulo="* Módulos"
        />
      )
    }

    return (
      <TableContainer component={Paper}>
        <Table aria-label="listagem de modulos disponíveis">
          <TableHead>
            <TableRow>
              <TableCell align='left'><strong>Módulos</strong></TableCell>
              <TableCell align='center'><strong>Quantidade</strong></TableCell>
              <TableCell align='center'><strong>Dados Técnicos</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {modulosList.map((row) => (
              <TableRow key={row.componente_id}>
                <TableCell style={{ maxWidth: '400px' }} align='right' component="th">
                  <Box display='flex'>
                    <Radio className={classes.radioButton} value={row.componente_id} checked={row.selecionado} onClick={() => handleSelect(row.componente_id)} />
                  
                    <Box textAlign={'left'}>
                      <Typography className={classes.moduleTitle} variant='body1' color='textPrimary'>
                        {row.nome}
                      </Typography>
                      {row.descricao && (
                        <Typography variant='body2' color='textSecondary'>
                        <span className={classes.warningText}>Atenção</span>: {row.descricao}
                        </Typography>
                      )}
                      {row.faturamento && (
                        <Typography variant='body2' color='textSecondary'>
                          Previsão de faturamento: {Formater.toString(row.faturamento, TypeRecords.DATE)}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </TableCell>
                <TableCell align='center' component="th">
                  {row.selecionado && (
                    <Box width="180px" margin={"0 auto"}>
                      <InputQuantidade value={row.quantidade} onChange={(v: any) => handleChangeModuleQuantity(row.componente_id, v)} />
                    </Box>
                  )}
                </TableCell>
                <TableCell align='center' component="th">
                  <Box display={"flex"} alignItems="center" justifyContent={"center"}>
                    <IconButton size="large" onClick={() => row.componente_id && changeModal({ detalhesComponenteId: row.componente_id })}>
                      <FindInPageOutlined htmlColor="black" />
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }, [classes, handleSelect, handleChangeModuleQuantity, modulosList])

  const renderInversoresHibridos = useCallback(() => {
    const itens = projetoState?.inversoresList || [];

    return (
      <Box mt={isMobile ? 0 : 4}>
        {isMobile ? (
            <InversoresListMobile 
              inversoresList={itens || []}
              handleOpenModalDadosTecnicos={changeModal}
              handleChangeInverterQuantity={(id: number, value: string) => handleChangeQuantity(id, value, itens/*, "inversor", checkInverterQuantityIsInvalid*/)}
              titulo="* Selecione a quantidade desejada de Inversores"
            />
          ) : (
            <TableContainer component={Paper}>
              <Table aria-label="listagem de inversores híbridos disponíveis">
                <TableHead>
                  <TableRow>
                    <TableCell align='left'><strong>Selecione a quantidade desejada de Inversores</strong></TableCell>
                    <TableCell align='center'><strong>Quantidade</strong></TableCell>
                    <TableCell align='center'><strong>Dados Técnicos</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {itens?.map((row) => (
                    <TableRow key={row.componente_id}>
                      <TableCell style={{ maxWidth: '400px' }} align='right' component="th">
                        <Box textAlign={'left'}>
                          <Typography className={classes.moduleTitle} variant='body1' color='textPrimary'>
                            {row.nome}
                          </Typography>
                          <Typography variant='body2' color='textSecondary'>
                            <span className={classes.warningText}>Informações</span>: {row.descricao}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell align='center' component="th">
                        <Box width="180px" margin={"0 auto"}>
                          <InputQuantidade
                            value={row.quantidade} 
                            maxValue={selectedModulo?.quantidade}
                            onChange={(v: any) => handleChangeQuantity(row.componente_id, v, itens/*, "inversor", checkInverterQuantityIsInvalid*/)} 
                          />
                        </Box>
                      </TableCell>

                      <TableCell align='center' component="th">
                        <Box display={"flex"} alignItems="center" justifyContent={"center"}>
                          <IconButton size="large" onClick={() => row.componente_id && changeModal({ detalhesComponenteId: row.componente_id })}>
                            <FindInPageOutlined htmlColor="black" />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )
        }
      </Box>
    );
  }, [projetoState?.inversoresList, selectedModulo, classes, handleChangeQuantity])

  const handleClickNext = useCallback(() => {
    onClickNext()
  },[onClickNext])

    return (
      <>
        <Layout
          nextButtonIsDisabled={nextButtonIsDisabled}
          nextButtonDisabledTooltip='Para prosseguir, selecione um módulo e preencha a quantidade de unidades desejada e posteriormente o inversor ideal para este projeto.'
          onClickBack={onClickBack}
          onClickNext={handleClickNext}
          title="Módulos e Inversores"
          subtitle="Escolha o módulo e o inversor ideal para compor o gerador e atender a demanda do seu cliente."
        >
          <Box p={2}>
            {renderModulos()}

            <Box mt={5}>
              <InputComboBoxList
                id={`select-tipos-inversor`}
                key={`select-tipos-inversor`}
                label={"* Tipo de inversor"}
                textField="tipos_inversor"
                valueField="id"
                options={[]}
                value={tipoInversor}
                disabled
                autoComplete
                renderOptions={(option: any) => {
                    return `${option.text}`
                }}
                renderOptionsLabel={(option: any) => {
                    return `${option.text}`
                }}
                onChange={() => {}}
                />
            </Box>
            {renderInversoresHibridos()}
          </Box>
        </Layout>
      </>
    )
}

export { Gerador }